import { useId, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Draggable, Droppable } from 'react-beautiful-dnd'
import { Icon } from '@iconify/react'

// antd
import {
    Card,
    Col,
    Input,
    Row,
    Space,
    Tooltip,
    Typography,
    message,
    Badge,
    Popover,
    theme,
} from 'antd'
import { CheckOutlined, BugOutlined } from '@ant-design/icons'

// slices
import {
    changeEditInput,
    createEpicList,
    deleteEpicList,
    epicsList,
    setEpics,
    setSprintTasks,
    sprintsList,
    sprintsState,
    taskSprintList,
    updateEpicList,
} from './sprints.slice'
import {
    switchFormModal,
    taskById,
    taskDelete,
    // taskUpdate,
} from '../tasks/tasks.slice'
import { loginState } from '../login/login.slice'
import { projectsState } from '../projects/projects.slice'
import { taskCreate, taskUpdate } from '../taskRefactored/tasks.slice'

// components
import Button from '../../components/button/button'
import DeletePopUp from '../../components/deletePopUp/deletePopUp'
import AssigneeSelectPopover from '../taskRefactored/components/assigneeSelector'

// assets
import { DeleteIcon } from '../../assets/icons'

// css
import styles from './sprints.module.css'

// helpers
import { useRandomId } from '../../helpers/useRandomId'
import { estimateFn } from '../../helpers/estimationCalculation'
import { cleanObject } from '../../helpers/removeEmptyObjectValue'
import {
    addPermissionCheck,
    deletePermissionCheck,
    editPermissionCheck,
} from '../../helpers/permissionCheck'

import CreateTaskCardSprint from './components/createTaskCardSprint'

const EpicCardSectionFinal = ({ props }) => {
    const { useToken } = theme
    const { token } = useToken()
    const { Text } = Typography
    const { card, sprintId, filteredAssignees } = props
    const { _id, title, position } = card

    const memoizedFilteredAssignees = useMemo(
        () => filteredAssignees,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [filteredAssignees]
    )

    const createEpicId = useId()

    const createTaskId = useRandomId()

    const dispatch = useDispatch()

    const {
        epics,
        editInput,
        skipPageEpic,
        pageLimitEpic,
        pageLimitTask,
        skipPageTask,
        pointerEvent,
        listTasks: tasks,
    } = useSelector(sprintsState)
    const { currentProjectData } = useSelector(projectsState)
    const { userProfile } = useSelector(loginState)

    const initialState = {
        epicTitle: '',
        deleteEpicModal: false,
        deleteButtonLoading: false,
        deleteModal: false,
        deleteButtonLoadingTask: false,
        taskID: '',
        deleteCheck: false,
        open: false,
    }

    const [state, setState] = useState(initialState)
    const [createEpicLoading, setCreateEpicLoading] = useState(false)

    const handleOpenChange = (newOpen) => {
        setState({ ...state, open: newOpen })
    }

    // DELETE TASK
    async function deleteTask() {
        const result = await dispatch(taskDelete(state?.taskID))
        const data = result?.payload?.data
        if (data) {
            const { success, message: checkMessage } = data
            if (success) {
                setState({
                    ...state,
                    deleteButtonLoadingTask: false,
                    deleteModal: false,
                    taskID: '',
                })
                message.success(checkMessage)
                dispatch(sprintsList())
                dispatch(
                    epicsList({ skip: skipPageEpic, limit: pageLimitEpic })
                )
            } else {
                setState({
                    ...state,
                    deleteButtonLoadingTask: false,
                    deleteModal: false,
                    taskID: '',
                })
                if (checkMessage) {
                    message.error(checkMessage)
                } else {
                    message.error('Something went wrong, try again later.')
                }
            }
        }
    }

    async function updateTaskAssignee(value, Id) {
        dispatch(
            taskUpdate({
                updateTask: {
                    assigneeId: value,
                },
                _id: Id,
            })
        )
    }

    // CREATE NEW EPIC CARD
    const createEpicCard = (id) => {
        const newEpics = structuredClone(epics)

        // AFTER ARRAY FROM EPIC CREATE

        const index = newEpics.findIndex((x) => x._id === id)

        let newAfterArray = []
        // ADD CREATE EPIC CARD AND REMOVE OTHER DATA
        if (newEpics[index + 1]?.type !== 'create') {
            const afterArray = newEpics.slice(index + 1)

            // UPDATED NEW AFTER ARRAY
            if (afterArray?.length > 0) {
                afterArray.map((data) =>
                    newAfterArray.push({
                        ...data,
                        position: data?.position + 1,
                    })
                )
            }
            newEpics.splice(
                newEpics.findIndex((x) => x._id === id) + 1,
                newAfterArray?.length,
                {
                    position: newEpics.findIndex((x) => x._id === id) + 1,
                    projectId: JSON.parse(
                        localStorage.getItem('currentProject')
                    )?.id,
                    _id: createEpicId,
                    type: 'create',
                }
            )
        }
        dispatch(setEpics([...newEpics, ...newAfterArray]))
    }
    // CREATE NEW TASK CARD
    const createTaskCard = (columnId) => {
        const sprintName = JSON.parse(
            localStorage.getItem('currentSprint')
        )?.name

        const newTasks = structuredClone(tasks)

        const columnIndex = newTasks.findIndex((x) => x._id === columnId)

        if (columnIndex === -1) return

        const list = newTasks[columnIndex]?.list || []

        const lastPosition =
            list?.length > 0 ? list[list.length - 1]?.position : -1
        const updatedList = [
            ...(newTasks[columnIndex]?.list || []),
            {
                _id: createTaskId,
                taskType: 'create',
                projectId: JSON.parse(localStorage.getItem('currentProject'))
                    ?.id,
                position: lastPosition + 1,
                sprintId,
                status: 'To Do',
                title: '',
                assigneeId: '',
                loading: false,
                type:
                    sprintName === 'Backlog'
                        ? 'Task'
                        : sprintName === 'Issues'
                        ? 'Bug'
                        : '',
                epic: columnId,
            },
        ]

        // Replace only the list of that column
        newTasks[columnIndex].list = updatedList

        dispatch(setSprintTasks([...newTasks]))
    }

    const cancelCreateTask = (columnId, taskId) => {
        const newTasks = structuredClone(tasks)

        const columnIndex = newTasks.findIndex((col) => col._id === columnId)

        if (columnIndex === -1) return

        const taskList = newTasks[columnIndex].list

        const taskIndex = taskList.findIndex((task) => task._id === taskId)
        if (taskIndex === -1) return

        const removedTask = taskList[taskIndex]

        const removedPosition = removedTask.position

        const updatedList = taskList.filter((task) => task._id !== taskId)

        const reorderedList = updatedList.map((task) => {
            if (task?.position > removedPosition) {
                return {
                    ...task,
                    position: task.position - 1,
                }
            }
            return task
        })

        newTasks[columnIndex].list = reorderedList

        dispatch(setSprintTasks(newTasks))
    }

    const setCreateTask = (columnId, taskId, updatedFields) => {
        const newTasks = structuredClone(tasks)

        const columnIndex = newTasks.findIndex((col) => col._id === columnId)
        if (columnIndex === -1) return

        const taskList = newTasks[columnIndex].list
        const taskIndex = taskList.findIndex((task) => task._id === taskId)
        if (taskIndex === -1) return

        newTasks[columnIndex].list[taskIndex] = {
            ...newTasks[columnIndex].list[taskIndex],
            ...updatedFields,
        }

        dispatch(setSprintTasks(newTasks))
    }

    console.log(tasks)

    // CREATE NEW EPIC
    const createEpic = async (position) => {
        let result

        if (editInput?.open) {
            result = await dispatch(
                updateEpicList({
                    epicEdit: {
                        title: state?.epicTitle,
                    },
                    id: editInput?.id,
                })
            )
        } else {
            result = await dispatch(
                createEpicList({
                    projectId: JSON.parse(
                        localStorage.getItem('currentProject')
                    )?.id,
                    title: state?.epicTitle,
                    position: position,
                })
            )
        }
        const data = result?.payload?.data
        if (data) {
            dispatch(
                changeEditInput({
                    open: false,
                    id: '',
                })
            )
            const { success, message: checkMessage } = data
            if (success) {
                await dispatch(
                    epicsList({ skip: skipPageEpic, limit: pageLimitEpic })
                )
                setCreateEpicLoading(false)
                await dispatch(
                    taskSprintList({
                        skip: skipPageTask,
                        limit: pageLimitTask,
                        projectId: JSON.parse(
                            localStorage.getItem('currentProject')
                        )?.id,
                        sprintId,
                    })
                )
                message.success(checkMessage)
            } else {
                setCreateEpicLoading(false)
                if (typeof checkMessage === 'object') {
                    for (const key in checkMessage) {
                        message.error(checkMessage[key])
                    }
                } else if (typeof checkMessage === 'string') {
                    message.error(checkMessage)
                } else {
                    message.error('Something went wrong, try again later.')
                }
            }
        }
    }

    // CANCEL NEW EPIC
    const cancelEpic = (position) => {
        const newEpics = structuredClone(epics)
        newEpics.splice(position, 1)
        const afterArray = []
        newEpics.map((data, index) =>
            afterArray.push({ ...data, position: index })
        )
        dispatch(setEpics(afterArray))
    }

    // VIEW TASK
    async function viewTask(taskID) {
        dispatch(
            switchFormModal({
                open: true,
            })
        )
        dispatch(taskById({ _id: taskID }))
    }

    // DELETE EPIC
    async function deleteEpic() {
        setState({ ...state, deleteButtonLoading: true })

        const result = await dispatch(deleteEpicList(_id))
        const data = result?.payload?.data
        if (data) {
            const { success, message: checkMessage } = data
            if (success) {
                setState({
                    ...state,
                    deleteEpicModal: false,
                    deleteButtonLoading: false,
                })
                dispatch(
                    epicsList({ skip: skipPageEpic, limit: pageLimitEpic })
                )
                message.success(checkMessage)
            } else {
                if (checkMessage) {
                    setState({
                        ...state,
                        deleteEpicModal: false,
                        deleteButtonLoading: false,
                    })
                    message.error(checkMessage)
                } else {
                    setState({
                        ...state,
                        deleteEpicModal: false,
                        deleteButtonLoading: false,
                    })
                    message.error('Something went wrong, try again later.')
                }
            }
        }
    }

    // DELETE TASK CONDITION COMPONENT
    const DeleteTaskComponent = () => 'Delete'

    const CardSection = ({ props }) => {
        const { card } = props
        const { _id, title, epicPosition, type, status } = card
        const [epicDropDown, setEpicDropDown] = useState(false)

        const handleOpenEpicChange = (newOpen) => {
            setEpicDropDown(newOpen)
        }
        return (
            <>
                <Draggable key={_id} draggableId={_id} index={epicPosition}>
                    {(provided) => {
                        return (
                            <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                onClick={(e) => {
                                    const shouldIgnore =
                                        e.target.closest(
                                            '[data-ignore-click]'
                                        ) ||
                                        e.target.closest('.ignore-view-task') ||
                                        e.target.closest(
                                            '.ant-avatar-string'
                                        ) ||
                                        e.target.closest('.ant-image') ||
                                        e.target.tagName === 'svg' ||
                                        e.target.tagName === 'path'

                                    if (!shouldIgnore && !state?.deleteCheck) {
                                        viewTask(_id)
                                    }
                                }}
                            >
                                <Card
                                    variant="borderless"
                                    className={styles.epicCard}
                                    title={null}
                                    style={{
                                        borderRadius: '6px',
                                        marginTop: '15px',
                                    }}
                                    styles={{
                                        body: {
                                            padding: '10px 16px',
                                            minHeight: '100%',
                                        },
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'space-between',
                                            rowGap: '26px',
                                        }}
                                    >
                                        <Row
                                            align={'middle'}
                                            justify={'space-between'}
                                        >
                                            {title?.length > 27 ? (
                                                <Tooltip
                                                    title={title}
                                                    arrow={false}
                                                    placement="bottom"
                                                    align={{ offset: [200, 0] }}
                                                    styles={{
                                                        body: {
                                                            backgroundColor:
                                                                '#fff',
                                                            color: '#000',
                                                            border: '1px solid #000',
                                                        },
                                                    }}
                                                >
                                                    <Text
                                                        style={{
                                                            textTransform:
                                                                'capitalize',
                                                            fontWeight:
                                                                token.fontWeightStrong,
                                                            cursor: 'pointer',
                                                        }}
                                                        ellipsis={{
                                                            rows: 1,
                                                            expandable: false,
                                                        }}
                                                        onClick={() => {}}
                                                    >
                                                        {title
                                                            .substring(0, 27)
                                                            .concat('...')}
                                                    </Text>
                                                </Tooltip>
                                            ) : (
                                                <Text
                                                    style={{
                                                        textTransform:
                                                            'capitalize',
                                                        fontWeight:
                                                            token.fontWeightStrong,
                                                    }}
                                                    ellipsis={{
                                                        rows: 1,
                                                        expandable: false,
                                                    }}
                                                    onClick={() => {}}
                                                >
                                                    {title}
                                                </Text>
                                            )}

                                            <Popover
                                                content={dropDownContent(
                                                    dropDownEpicIcon,
                                                    _id
                                                )}
                                                trigger="click"
                                                placement="bottom"
                                                open={epicDropDown}
                                                styles={{
                                                    body: {
                                                        padding: '10px',
                                                    },
                                                }}
                                                arrow={false}
                                                onOpenChange={
                                                    handleOpenEpicChange
                                                }
                                            >
                                                <Icon
                                                    icon="uil:ellipsis-v"
                                                    height={17}
                                                    width={17}
                                                    className={
                                                        styles.epicEllipsisIcon
                                                    }
                                                    color="#313131"
                                                />
                                            </Popover>
                                        </Row>
                                        <Row
                                            justify={'space-between'}
                                            align={'middle'}
                                        >
                                            <Col>
                                                <Row align={'middle'}>
                                                    <Space size={'small'}>
                                                        <Tooltip
                                                            title={type}
                                                            arrow={false}
                                                            placement="bottom"
                                                            classNames={{
                                                                body: 'tooltip-global',
                                                            }}
                                                        >
                                                            {type === 'Bug' ? (
                                                                <div
                                                                    className={
                                                                        styles.taskTypeSection
                                                                    }
                                                                    style={{
                                                                        backgroundColor:
                                                                            'red',
                                                                    }}
                                                                >
                                                                    <BugOutlined
                                                                        style={{
                                                                            fontSize:
                                                                                '12px',
                                                                            color: 'white',
                                                                        }}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <div
                                                                    className={
                                                                        styles.taskTypeSection
                                                                    }
                                                                    style={{
                                                                        backgroundColor:
                                                                            token
                                                                                .colorPalette
                                                                                .baseColor
                                                                                .tertiary,
                                                                    }}
                                                                >
                                                                    <CheckOutlined
                                                                        style={{
                                                                            fontSize:
                                                                                '10px',
                                                                            color: 'white',
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </Tooltip>
                                                        <Tooltip
                                                            arrow={false}
                                                            title={`Status : ${status}`}
                                                            placement="bottom"
                                                            classNames={{
                                                                body: 'tooltip-global',
                                                            }}
                                                        >
                                                            <div
                                                                className={
                                                                    styles.taskTypeSection
                                                                }
                                                                style={{
                                                                    backgroundColor:
                                                                        status ===
                                                                        'To Do'
                                                                            ? '#d5d5d5'
                                                                            : status ===
                                                                              'Done'
                                                                            ? '#C8E5CE'
                                                                            : '#05445E',
                                                                }}
                                                            ></div>
                                                        </Tooltip>
                                                        <Text
                                                            className={
                                                                styles.keyText
                                                            }
                                                            // onClick={() => viewTask(_id)}
                                                        >
                                                            {card?.taskKey}
                                                        </Text>
                                                    </Space>
                                                </Row>
                                            </Col>
                                            <Row align={'middle'}>
                                                <Space size={'small'}>
                                                    <Tooltip
                                                        arrow={false}
                                                        title={
                                                            card?.estimation ===
                                                            0
                                                                ? 'Unestimated'
                                                                : estimateFn(
                                                                      card?.estimation,
                                                                      currentProjectData
                                                                  )
                                                        }
                                                        placement="bottom"
                                                        classNames={{
                                                            body: 'tooltip-global',
                                                        }}
                                                    >
                                                        <Badge
                                                            count={
                                                                card?.estimation ===
                                                                0
                                                                    ? '0m'
                                                                    : estimateFn(
                                                                          card?.estimation,
                                                                          currentProjectData
                                                                      )
                                                            }
                                                            color="#85BBF9"
                                                            style={{
                                                                minWidth:
                                                                    '30px',
                                                                cursor: 'auto',
                                                            }}
                                                        />
                                                    </Tooltip>
                                                    <div
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        draggable={'false'}
                                                        data-ignore-click
                                                        className="ignore-view-task"
                                                        onClick={(e) =>
                                                            e.stopPropagation()
                                                        }
                                                    >
                                                        <AssigneeSelectPopover
                                                            assigneeList={
                                                                memoizedFilteredAssignees
                                                            }
                                                            value={
                                                                card?.info
                                                                    ?.assigneeId[0]
                                                                    ?._id
                                                            }
                                                            onChange={(
                                                                selected,
                                                                option
                                                            ) => {
                                                                const newTasks =
                                                                    structuredClone(
                                                                        tasks
                                                                    )

                                                                for (const column of newTasks) {
                                                                    if (
                                                                        !Array.isArray(
                                                                            column.list
                                                                        )
                                                                    )
                                                                        continue

                                                                    const taskIndex =
                                                                        column.list.findIndex(
                                                                            (
                                                                                task
                                                                            ) =>
                                                                                task &&
                                                                                task._id ===
                                                                                    card._id
                                                                        )

                                                                    if (
                                                                        taskIndex !==
                                                                        -1
                                                                    ) {
                                                                        const task =
                                                                            column
                                                                                .list[
                                                                                taskIndex
                                                                            ]

                                                                        task.assigneeId =
                                                                            option?.value

                                                                        task.info.assigneeId =
                                                                            [
                                                                                {
                                                                                    _id: option?.value,
                                                                                    name: option?.label,
                                                                                    profilePicture:
                                                                                        option?.profilePicture ||
                                                                                        '',
                                                                                },
                                                                            ]

                                                                        break
                                                                    }
                                                                }

                                                                dispatch(
                                                                    setSprintTasks(
                                                                        newTasks
                                                                    )
                                                                )

                                                                updateTaskAssignee(
                                                                    selected,
                                                                    card?._id
                                                                )
                                                            }}
                                                            placement="bottom"
                                                            assigneeEmptyShow={
                                                                false
                                                            }
                                                            searchable
                                                            // ref={popoverRef}
                                                        />
                                                    </div>
                                                </Space>
                                            </Row>
                                        </Row>
                                    </div>
                                </Card>
                            </div>
                        )
                    }}
                </Draggable>
            </>
        )
    }

    const dropDownIcon = [
        {
            title: deletePermissionCheck('epics', userProfile) ? (
                'Delete'
            ) : (
                <Tooltip
                    arrow={false}
                    placement="bottom"
                    title="You don't have permission to delete task"
                >
                    Delete
                </Tooltip>
            ),
            icon: <DeleteIcon />,
            onClick: () => {
                setState((prevState) => ({ ...prevState, open: false }))
                if (deletePermissionCheck('epics', userProfile)) {
                    setState((prevState) => ({
                        ...prevState,
                        deleteEpicModal: true,
                    }))
                }
            },
        },
    ]

    const dropDownEpicIcon = [
        {
            title: deletePermissionCheck('tasks', userProfile) ? (
                <DeleteTaskComponent />
            ) : (
                <Tooltip
                    arrow={false}
                    placement="bottom"
                    title="You don't have permission to delete task"
                >
                    Delete
                </Tooltip>
            ),
            icon: <DeleteIcon />,
            onClick: (_id) => {
                if (deletePermissionCheck('tasks', userProfile)) {
                    setState({
                        ...state,
                        deleteCheck: true,
                        taskID: _id,
                        deleteModal: true,
                    })
                }
            },
        },
    ]

    const dropDownContent = (dropDownIcon, _id) => {
        return (
            <>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: '8px',
                    }}
                >
                    {dropDownIcon?.length > 0 &&
                        dropDownIcon.map((data) => (
                            <Row
                                style={{
                                    cursor: 'pointer',
                                }}
                                align={'middle'}
                                onClick={(e) => {
                                    data?.onClick(_id)
                                    e.stopPropagation()
                                }}
                            >
                                <div
                                    style={{
                                        marginRight: '10px',
                                    }}
                                >
                                    {data?.icon}
                                </div>
                                <Text className="sub-title">{data?.title}</Text>
                            </Row>
                        ))}
                </div>
            </>
        )
    }

    const createTaskFromBoard = async (card, columnId) => {
        // setCreateTask((prevState) => ({
        //     ...prevState,
        //     loading: true,
        // }))
        const { _id, loading, taskType, ...rest } = card

        const newTasks = structuredClone(tasks)

        const columnIndex = newTasks.findIndex((col) => col._id === columnId)

        if (columnIndex === -1) return

        const taskList = newTasks[columnIndex].list

        const taskIndex = taskList.findIndex((task) => task._id === _id)
        if (taskIndex === -1) return

        let findTask = taskList[taskIndex]

        if (findTask) {
            findTask.loading = true
        }

        dispatch(setSprintTasks(newTasks))

        const payload = cleanObject({
            ...rest,
        })

        const result = await dispatch(taskCreate(payload))

        const data = result?.payload?.data
        if (data) {
            const { success } = data
            if (success) {
                await dispatch(
                    taskSprintList({
                        skip: skipPageTask,
                        limit: pageLimitTask,
                        projectId: JSON.parse(
                            localStorage.getItem('currentProject')
                        )?.id,
                        sprintId,
                    })
                )
                // setCreateTask(initialCreateTask)
            } else {
                // setCreateTask(initialCreateTask)
            }
        } else {
            // setCreateTask(initialCreateTask)
        }
    }

    return (
        <>
            <DeletePopUp
                previewDelete={state?.deleteEpicModal}
                onDelete={() => {
                    deleteEpic()
                }}
                loadingButton={state?.deleteButtonLoading}
                onCancel={() => {
                    setState({
                        ...state,
                        deleteButtonLoading: false,
                        deleteEpicModal: false,
                    })
                }}
                modalTitle="Delete Epic"
                pageKey="epic"
            />
            <DeletePopUp
                previewDelete={state?.deleteModal}
                onDelete={() => {
                    setState({
                        ...state,
                        deleteButtonLoadingTask: true,
                        deleteCheck: false,
                    })
                    deleteTask()
                }}
                loadingButton={state?.deleteButtonLoadingTask}
                onCancel={() => {
                    setState({
                        ...state,
                        deleteCheck: false,
                        deleteButtonLoadingTask: false,
                        deleteModal: false,
                    })
                }}
                modalTitle="Delete Task"
                pageKey="Task"
            />
            <Draggable
                key={_id}
                draggableId={_id}
                index={position}
                isDragDisabled={card?.type === 'create'}
            >
                {(provided) => (
                    <>
                        <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={10}
                            xl={6}
                            xxl={5}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                                height: 'max-content',
                                ...provided.draggableProps.style,
                                pointerEvents: pointerEvent ? 'auto' : 'none',
                            }}
                        >
                            <Card
                                bordered={false}
                                className={styles.epicCard}
                                title={<div></div>}
                                style={{
                                    borderRadius: '6px',
                                }}
                                styles={{
                                    body: {
                                        padding: '10px 16px',
                                        minHeight: '100%',
                                        opacity: createEpicLoading ? 0.5 : 1,
                                        pointerEvents: createEpicLoading
                                            ? 'none'
                                            : 'auto',
                                    },
                                    header: {
                                        backgroundColor:
                                            token.colorPalette.baseColor
                                                .tertiary,
                                        minHeight: '6px',
                                    },
                                }}
                            >
                                {createEpicLoading && (
                                    <div className={styles.loaderEpic}></div>
                                )}
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        rowGap:
                                            card?.type === 'create'
                                                ? '16px'
                                                : '26px',
                                    }}
                                >
                                    <Row
                                        align={'middle'}
                                        justify={'space-between'}
                                    >
                                        {card?.type === 'create' ||
                                        (editInput.id === _id &&
                                            editPermissionCheck(
                                                'epics',
                                                userProfile
                                            )) ? (
                                            <Input
                                                style={{
                                                    textTransform: 'capitalize',
                                                    backgroundColor:
                                                        'transparent',
                                                }}
                                                autoFocus
                                                name="epicTitle"
                                                className="active-epic"
                                                defaultValue={title}
                                                onKeyUp={(e) => {
                                                    if (!createEpicLoading) {
                                                        if (
                                                            e.target.value
                                                                ?.length > 0
                                                        ) {
                                                            if (
                                                                e.key ===
                                                                    'Enter' ||
                                                                e.key === 13
                                                            ) {
                                                                if (
                                                                    e.target.value[0].includes(
                                                                        ' '
                                                                    )
                                                                ) {
                                                                    message.error(
                                                                        'No space is allowed at the beginning'
                                                                    )
                                                                } else if (
                                                                    e.target
                                                                        .value
                                                                        ?.length >
                                                                    20
                                                                ) {
                                                                    message.error(
                                                                        'Epic name should be maximum 20 characters long'
                                                                    )
                                                                } else {
                                                                    setCreateEpicLoading(
                                                                        true
                                                                    )
                                                                    createEpic(
                                                                        position
                                                                    )
                                                                }
                                                            }
                                                        } else if (
                                                            e.key !==
                                                                'Backspace' &&
                                                            e.key !== 8
                                                        ) {
                                                            message.error(
                                                                'Epic name should not be empty'
                                                            )
                                                        }
                                                        setState({
                                                            ...state,
                                                            epicTitle:
                                                                e.target.value.trimStart(),
                                                        })
                                                    }
                                                }}
                                            />
                                        ) : (
                                            <Text
                                                style={{
                                                    textTransform: 'capitalize',
                                                    cursor: 'pointer',
                                                    fontWeight: 600,
                                                }}
                                                onClick={() => {
                                                    dispatch(
                                                        changeEditInput({
                                                            open: true,
                                                            id: _id,
                                                        })
                                                    )
                                                }}
                                            >
                                                {title?.length > 30
                                                    ? title
                                                          .substring(0, 30)
                                                          .concat('...')
                                                    : title}
                                            </Text>
                                        )}
                                        {card?.type !== 'create' &&
                                            title !== 'general' &&
                                            editInput?.id !== _id && (
                                                <Popover
                                                    content={dropDownContent(
                                                        dropDownIcon
                                                    )}
                                                    trigger="click"
                                                    placement="bottom"
                                                    open={state?.open}
                                                    styles={{
                                                        body: {
                                                            padding: '10px',
                                                        },
                                                    }}
                                                    arrow={false}
                                                    onOpenChange={
                                                        handleOpenChange
                                                    }
                                                >
                                                    <Icon
                                                        icon="uil:ellipsis-v"
                                                        height={17}
                                                        width={17}
                                                        color="#313131"
                                                        className={
                                                            styles.epicEllipsisIcon
                                                        }
                                                    />
                                                </Popover>
                                            )}
                                    </Row>
                                    <Row
                                        justify={'space-between'}
                                        align={'middle'}
                                        style={{
                                            flexWrap: 'nowrap',
                                        }}
                                    >
                                        <Row
                                            align={'middle'}
                                            justify="space-between"
                                            style={{
                                                columnGap: '10px',
                                                width: '100%',
                                            }}
                                        >
                                            <Tooltip
                                                title="Epic"
                                                arrow={false}
                                                placement="bottom"
                                                classNames={{
                                                    body: 'tooltip-global',
                                                }}
                                            >
                                                <div>
                                                    <Icon
                                                        icon="mdi:thunder"
                                                        color={
                                                            token.colorPalette
                                                                .baseColor
                                                                .tertiary
                                                        }
                                                        width={22}
                                                        height={22}
                                                    />
                                                </div>
                                            </Tooltip>
                                            {card?.epicKey && (
                                                <Text
                                                    style={{
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    {card?.epicKey}
                                                </Text>
                                            )}
                                        </Row>
                                        {card?.type === 'create' && (
                                            <Row
                                                style={{
                                                    float: 'right',
                                                }}
                                            >
                                                <Row
                                                    align="middle"
                                                    style={{
                                                        columnGap: '5px',
                                                        flexFlow: 'nowrap',
                                                    }}
                                                >
                                                    <Button
                                                        props={{
                                                            disabled:
                                                                state?.epicTitle
                                                                    ?.length ===
                                                                0,
                                                            buttonType: 'text',
                                                            styles: {
                                                                width: 'auto',
                                                            },
                                                            className:
                                                                'createTaskSprintBoard',
                                                            onClick: () => {
                                                                if (
                                                                    !createEpicLoading
                                                                ) {
                                                                    if (
                                                                        state
                                                                            ?.epicTitle
                                                                            ?.length >
                                                                        0
                                                                    ) {
                                                                        if (
                                                                            state?.epicTitle[0].includes(
                                                                                ' '
                                                                            )
                                                                        ) {
                                                                            message.error(
                                                                                'No space is allowed at the beginning'
                                                                            )
                                                                        } else if (
                                                                            state
                                                                                ?.epicTitle
                                                                                ?.length >
                                                                            20
                                                                        ) {
                                                                            message.error(
                                                                                'Epic name should be maximum 20 characters long'
                                                                            )
                                                                        } else {
                                                                            setCreateEpicLoading(
                                                                                true
                                                                            )
                                                                            createEpic(
                                                                                position
                                                                            )
                                                                        }
                                                                    } else {
                                                                        message.error(
                                                                            'Epic name should not be empty'
                                                                        )
                                                                    }
                                                                }
                                                            },
                                                            icon: (
                                                                <div className="createTaskSprintBtn">
                                                                    <Icon
                                                                        icon="uil:enter"
                                                                        height={
                                                                            15
                                                                        }
                                                                        width={
                                                                            15
                                                                        }
                                                                    />
                                                                </div>
                                                            ),
                                                        }}
                                                    />
                                                    <Button
                                                        props={{
                                                            buttonType: 'text',
                                                            styles: {
                                                                width: 'auto',
                                                            },
                                                            className:
                                                                'createTaskSprintBoard',
                                                            onClick: () => {
                                                                cancelEpic(
                                                                    position
                                                                )
                                                            },
                                                            icon: (
                                                                <div className="createTaskSprintBtn">
                                                                    <Icon
                                                                        icon="maki:cross"
                                                                        height={
                                                                            10
                                                                        }
                                                                        width={
                                                                            10
                                                                        }
                                                                    />
                                                                </div>
                                                            ),
                                                        }}
                                                    />
                                                </Row>
                                            </Row>
                                        )}
                                    </Row>
                                </div>
                                {addPermissionCheck('epics', userProfile) && (
                                    <div className={styles.epicCreate}>
                                        <div
                                            style={{
                                                backgroundColor: '#4F46E5',
                                                height: '20px',
                                                width: '20px',
                                                borderRadius: 3,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                opacity: 1,
                                                zIndex: 999999,
                                            }}
                                            onClick={() => {
                                                createEpicCard(_id)
                                            }}
                                        >
                                            <Icon
                                                icon="line-md:plus"
                                                color="#fff"
                                            />
                                        </div>
                                        <div
                                            style={{
                                                backgroundColor: '#4F46E5',
                                                height: '85px',
                                                width: '2px',
                                                borderRadius: 5,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        />
                                    </div>
                                )}
                            </Card>
                            <Droppable
                                droppableId={_id}
                                type={'column'}
                                direction={'vertical'}
                            >
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        className={styles.column}
                                        style={{
                                            display: 'flex',
                                            height: 'fitContent',
                                            flexDirection: 'column',
                                        }}
                                        {...provided.droppableProps}
                                    >
                                        {tasks?.length > 0 &&
                                            tasks.map(
                                                (item) =>
                                                    item?.list?.length > 0 &&
                                                    item?._id === _id &&
                                                    item?.list.map((card) =>
                                                        card?.taskType ===
                                                        'create' ? (
                                                            <div
                                                                style={{
                                                                    marginTop:
                                                                        '15px',
                                                                }}
                                                                key={card?._id}
                                                            >
                                                                <CreateTaskCardSprint
                                                                    filteredAssignees={
                                                                        memoizedFilteredAssignees
                                                                    }
                                                                    setCreateTask={(
                                                                        fields
                                                                    ) =>
                                                                        setCreateTask(
                                                                            item?._id,
                                                                            card?._id,
                                                                            fields
                                                                        )
                                                                    }
                                                                    cancelCreateTask={() =>
                                                                        cancelCreateTask(
                                                                            item?._id,
                                                                            card?._id
                                                                        )
                                                                    }
                                                                    createTask={
                                                                        card
                                                                    }
                                                                    createTaskFromBoard={() =>
                                                                        createTaskFromBoard(
                                                                            card,
                                                                            item?._id
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        ) : (
                                                            card?.info
                                                                ?.parentTask
                                                                ?.length ===
                                                                0 && (
                                                                <CardSection
                                                                    key={
                                                                        card?._id
                                                                    }
                                                                    props={{
                                                                        card,
                                                                    }}
                                                                />
                                                            )
                                                        )
                                                    )
                                            )}

                                        {card?.type !== 'create' && (
                                            <div
                                                style={{
                                                    marginTop: '15px',
                                                }}
                                                className={styles.epicCardLayer}
                                                onClick={() => {
                                                    createTaskCard(_id)
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        backgroundColor:
                                                            '#4F46E5',
                                                        height: '20px',
                                                        width: '20px',
                                                        borderRadius: 3,
                                                        display: 'flex',
                                                        justifyContent:
                                                            'center',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <Icon
                                                        icon="line-md:plus"
                                                        color="#fff"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </Col>
                    </>
                )}
            </Draggable>
        </>
    )
}

export default EpicCardSectionFinal
